import { NgModule } from '@angular/core';
import { ImagePreloadDirective } from './image-preload.directive';

@NgModule({
  declarations: [
    ImagePreloadDirective
  ],
  exports: [
    ImagePreloadDirective
  ]
})
export class ImagePreloadModule { }
